import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '../../../core/services/config/config.service';
import { UtilityService } from '../../../core/services/utility/utility.service';
import { Pharmacy } from '../../models/pharmacy';
import { PharmacySearchParams } from '../../models/pharmacy-search-params';

@Injectable({
  providedIn: 'root',
})
export class PharmaciesService {
  private utilityService = inject(UtilityService);
  private configService = inject(ConfigService);
  private config = this.configService.config;

  pharmaciesEndpoint = `${this.config.patientApiUrl}/v1/PatientPortal/Pharmacies`;

  getPharmaciesSearch(searchParams: PharmacySearchParams, pageNumber: number): Observable<Pharmacy[]> {
    const url = `${this.pharmaciesEndpoint}/Search`;
    const body = {
      ...searchParams,
      pageNumber,
      pageSize: 10,
      sortDirection: 1,
      sortColumn: 'Name',
    };
    return this.utilityService.postRequest<Pharmacy[]>(url, body, { applyDefaultTimeout: true });
  }

  getPharmacyById(pharmacyId: number): Observable<Pharmacy> {
    const url = `${this.pharmaciesEndpoint}/${pharmacyId}`;
    return this.utilityService.getRequest<Pharmacy>(url);
  }
}
